module.exports =  {
    bindings: {},
    controller: customsOfficeListController,
    templateUrl: 'customs-offices/components/customs-office-list.html'
}

customsOfficeListController.$inject = [
    '$location',
    'customsOfficeDataService'
];

function customsOfficeListController(
    $location,
    customsOfficeDataService
) {
    var vm = {
        service: customsOfficeDataService,
        changeActivecustomsOffice: customsOfficeDataService.changeActivecustomsOffice,
        isLoading: false,
        loadMore: loadMore,
        setActiveCustomsOffice: setActiveCustomsOffice,
    };
    return vm;

    function loadMore() {
        return customsOfficeDataService.loadCustomsOffices();
    }

    function setActiveCustomsOffice(customsoffice) {
        $location.url('/customs-offices/' + customsoffice.ReferenceNumber);
    }
}